const NS = 'SectionRequired';

export default function SectionRequired() {
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope, element, attrs, ngModel) {

    var validate = function (viewValue) {
      var selectedLayouts = false;
      if (attrs.sectionRequired) {
        selectedLayouts = JSON.parse(attrs.sectionRequired);
      }
      if (!selectedLayouts) {
        ngModel.$setValidity('section-required', false);
      } else {
        var valid = false;
        for (var key in selectedLayouts) {
          if (selectedLayouts[key] !== 'closed' && selectedLayouts[key] !== "not-used") {
            valid = true;
          }
        }
        ngModel.$setValidity('section-required', valid);
      }
      return viewValue;
    };

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('sectionRequired', function () {
      // Whenever the comparison model changes we'll re-validate
      return validate(ngModel.$viewValue);
    });
  }
}
